// extracted by mini-css-extract-plugin
module.exports = {"menuArea":"VideoMenu_menuArea__1HI-4","menu":"VideoMenu_menu__3Z7Dn","nomenu":"VideoMenu_nomenu__t3VOu"};